module.exports = __webpack_public_path__ + "img/ico-web.2e220600.svg";